import { render, staticRenderFns } from "./b-ticket-directions-information.vue?vue&type=template&id=5ae9dc48&scoped=true"
import script from "./b-ticket-directions-information.vue?vue&type=script&setup=true&lang=ts"
export * from "./b-ticket-directions-information.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./b-ticket-directions-information.vue?vue&type=style&index=0&id=5ae9dc48&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9dc48",
  null
  
)

export default component.exports